import React from 'react';
import ReactDOM from 'react-dom/client';

import { unregister } from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

runServiceWorker();

root.render(<App />);

reportWebVitals();

function runServiceWorker() {
	if (process.env.NODE_ENV !== 'production') {
		return unregister();
	}

	if ('serviceWorker' in navigator) {
		window.addEventListener('load', () => {
			navigator.serviceWorker
				.register('/pwa/service-worker.js')
				.then((registration) => {
					console.log('SW registered: ', registration);
				})
				.catch((registrationError) => {
					console.log('SW registration failed: ', registrationError);
				});
		});
	}
}
